import Footer from './footer.element.js';

export default Footer;

Footer.define('wje-footer', Footer);
